/**
 * 配置各个子域环境之间的切换
 *
 * imgBaseUrl: 图片所在CDN地址
 * getBaseUrl(): 得到当前域名地址对应的接口地址
 * getSocketUrl(): 得到当前域名地址对应的websocket地址
 * getNewHost(): 
 *
 */

const imgBaseUrl = 'https://imagecdn.rocketbird.cn/'

function getBaseUrl () {
  let baseUrl,
    host = window.location.host,
    subDomain = host.split('.')[0]
  if (subDomain === 'vip') {
    baseUrl = 'https://wx.yuesports.chongqingexpo.com'
  } else if (subDomain === 'fe') {
    baseUrl = '/api'
  } else {
    baseUrl = 'http://beta.guobo.rocketbird.cn'
  }
  return baseUrl
}

function getSocketUrl () {
  let baseUrl,
    host = window.location.host,
    subDomain = host.split('.')[0]
  switch(subDomain){
    case 'vip-sim':
      baseUrl = 'wss://im-sim.guobo.rocketbird.cn'
      break;
    case 'vip':
      baseUrl = 'wss://im.guobo.rocketbird.cn'
      break;
    default:
      baseUrl = 'ws://im-beta.guobo.rocketbird.cn'
      break;
  }
  return baseUrl
}

const getNewHost = function () {
  let baseNewUrl,
    host = window.location.host,
    hostname = window.location.hostname,
    subDomain = host.split('.')[0]
  if (subDomain === 'vip') {
    baseNewUrl = ''
  } else if (subDomain === 'fe') {
    baseNewUrl = `http://${host}`
  } else {
    // 可能测试环境会带s 预留判断
    baseNewUrl = `http://${host}`
  }
  return baseNewUrl
}

export {
  getBaseUrl,
  getSocketUrl,
  imgBaseUrl,
  getNewHost
}
